import { AlertCircle, RefreshCw } from "lucide-react";

export function RouteLoading() {
  return (
    <div className="pa-route-loading" aria-live="polite">
      <div className="pa-skeleton-line" />
      <div className="pa-skeleton-grid">
        <div />
        <div />
        <div />
      </div>
    </div>
  );
}

export function RouteError({ title, detail, onRetry }: { title: string; detail: string; onRetry: () => void }) {
  return (
    <div className="pa-error-state">
      <span><AlertCircle size={34} /></span>
      <h1>{title}</h1>
      <p>{detail}</p>
      <button type="button" className="pa-primary-button" onClick={onRetry}>
        <RefreshCw size={17} />
        Retry
      </button>
    </div>
  );
}
